import { useState, useEffect, useRef } from 'react';
import ax, {
  GET_TAX_PREVIEW,
  GET_CART_ID, GET_CART,
  SET_CART, CONTROL_CART,
  GET_PRODUCT_ID,
  GET_SHIPPING_RATES
} from '%/axios';
import conso from '%/conso';
import { SHIP_WITH_WAREHOUSES } from '../utils/axios';


const init = {
  list: [],
  gift: null,
  coupons: [],
  shipping: { price: 0 }
}
const initTaxAmt = {
  amount: 0,
  rate: 0
};
const useCartCheckout = ({ poll = false } = {}) => {

  const [cartCheckout, setCartCheckout] = useState(init)
  const intervalRef = useRef();
  const [taxAmount, setTaxAmount] = useState(initTaxAmt);

  const [pickList, setPickList] = useState({});
  const [cartId, setCartId] = useState(0);
  const [shipping, setShipping] = useState({});


  const selectShippingRate = (selected, amount) => {
    setShipping(prev => ({ ...prev, selected: { ...selected, amount } }));
  }

  const getShippingRateWarehouse = async (address, list = [], cb = () => { }, count = 0) => {

    if(count > 7 || !address?.zip) return cb();
    
    if (!list?.length) {
      return cb();
    }

    try {

      const needsShippingCalculated = list.some(each => !each.free_shipping);
      
      const res = await ax(SHIP_WITH_WAREHOUSES, {
        productIds: list,
        address
      });

      if (
        res && (res[0]?.amount > 0 || !needsShippingCalculated)
      ) {
        const rate = res[0];
        const amount = res.reduce((acc, each) => acc + (Number(each.amount) || 0), 0);
        // rate.amount = amount;
        setShipping(prev => ({ ...prev, list: [rate], all: res, amount }));
      } else {

        setTimeout(() => {
          getShippingRateWarehouse(address, list, cb, count+1) 
        }, 3000)
        // cb();
        return;


      }
    } catch (er) {
      console.error(er);
    }
    cb();
  }

  const getShippingRates = async (city = '', address = {}, list = cartCheckout.list) => {
    if (!city) {
      return;
    }
    if (!list?.length) {
      return;

    }
    const productIds = list.map(each =>
      ({ id: each.product_id, quantity: each.quantity })
    );
    const productAddOnIds = list.reduce((acc, each) => {
      let stg = [];
      if (each.add_ons?.length) {
        stg = each.add_ons.map(add_on => ({ id: add_on.id, quantity: each.quantity }));
      }
      return acc.concat(...stg)

    }, []);
    try {
      const res = await ax(GET_SHIPPING_RATES, { city, productIds, productAddOnIds, address })

      if (res) {
        // filter for ups_ground and ups_ground_saver
        const filteredList = res.filter(each => {
          return ['ups_ground'].includes(each.servicelevel?.token || each.servicelevel?.extended_token)
        });
        setShipping(prev => ({ ...prev, list: filteredList }));
      }

    } catch (er) {
      console.error(er);
    }

  }

  const initCartId = async () => {
    try {
      const res = await ax(GET_CART_ID);
      if (res) {
        setCartId(res.id);
      }
    } catch (er) {
      conso.trace(er);
    }
  }
  const addCartItem = async (item = {}, quantity = 1) => {


    const res = await addToCartAPI(item, quantity);
    if (res?.line_items)
      setCartCheckout(prev => ({
        ...prev,
        list: res.line_items
      }))
  }

  const fillProductPrice = async (idx = 0) => {
    if (!cartCheckout.list[idx]?.price && cartCheckout.list[idx].product_id) {
      try {
        // const res = await ax(GET_PRODUCT_ID, {id: })
      } catch (er) {
        conso.error(er);
      }
    }
  }
  const removeCartItem = async (id, productId, productVariantId = null) => {
    try {
      const res = await removeFromCartAPI(id, productId, productVariantId);

      let idx = cartCheckout.list?.findIndex(each => each.id === id);

      if (idx < 0)
        idx = cartCheckout.list?.findIndex(each => each?.product?.id == productId);
      if (idx < 0) return;
      const cpy = [...(cartCheckout.list || [])];
      cpy.splice(idx, 1);


      setCartCheckout(prev => ({
        ...prev,
        list: cpy
      }));
    } catch (er) {

    }
  }

  const removeFromCartAPI = async (id, productId, productVariantId) => {
    const res = await ax(CONTROL_CART, {
      control: 'remove',
      lineItemId: id,
      productId,
      productVariantId
    })


    if (res) {
      // setCartCheckout(prev => ({
      //   ...prev,
      //   list: res
      // }));
    }
  }

  const addToCartAPI = async (item, quantity = 1) => {
    try {
      const res = await ax(SET_CART, {
        list: [{ product: item, quantity },
        ...cartCheckout.list].filter(each => each)
      })
      return res;
    } catch (er) {
      conso.trace(er);
    }
  }
  const initCartAPI = async () => {
    try {
      const res = await ax(GET_CART);
      if (res?.line_items) {
        const filtered = res.line_items.filter(each => each);
        setCartCheckout(prev => ({
          ...prev,
          list: filtered
        }))
        localStorage.setItem('cart', JSON.stringify(filtered))
      }


    } catch (er) {

    }
  }
  const initCartStorage = () => {
    intervalRef.current = setInterval(() => {
      const cart = JSON.parse(localStorage.getItem('cart'));
      if (cart) {
        setCartCheckout(prev => ({
          ...prev,
          list: cart
        }))
      }
    }, 3000)
  }
  const clearCartInterval = () => {
    clearInterval(intervalRef.current);
  }

  const initTaxRates = async (billing = null) => {
    try {
      const res = await ax(GET_TAX_PREVIEW, { billing })

      if (res) {
        setTaxAmount(prev => ({
          ...prev, rate: res
        }));
      }

    } catch (er) {
      console.error(er);
    }

  }

  const updateItemQuantity = (idx = -1, qty = 1) => {
    if (idx < 0) return;
    const cpy = [...cartCheckout.list];
    cpy[idx].quantity = qty;
    setCartCheckout(prev => ({
      ...prev,
      list: cpy
    }));
  }


  useEffect(() => {
    initCartAPI();
    // initCartStorage();
    initCartId();
    let a;
    if (poll) {
      a = setInterval(() => {
        initCartAPI();
      }, 5000)
    }
    return () => {
      clearCartInterval();
      clearInterval(a);
    }
  }, [])
  useEffect(() => {
    initTaxRates();
  }, [])

  return {
    cartCheckout,
    addCartItem,
    removeCartItem,
    cartId,
    initTaxRates,
    taxAmount,
    pickList, setPickList,
    getShippingRates,
    shipping,
    selectShippingRate,
    getShippingRateWarehouse,
    updateItemQuantity
  }
}
export default useCartCheckout;